import config from 'SRC/config/config.yaml'

export const adPriceTypes = config.adForm.addAdForm.adPriceTypes
